<template>
    <div class="banner">
        <div class="d-flex justify-content-center">
            <RewardsCardImg  class="digital-rewards-card" />
        </div>
        <p class="title text-center pt-3 mt-3">{{ bannerMessage }}</p>
    </div>
</template>

<script>
import RewardsCardImg from '@/components/RewardsCardImg.vue'

export default {
  name: 'SiteBanner',
  props: ['bannerMessage'],
  components: {
    RewardsCardImg
  },
  computed: {
    hasBannerMessage() {
      return this.bannerMessage && this.bannerMessage !== '';
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
    width: 100%;
    background-color: $light-grey-2;
    padding: 50px 30px;

    @media screen and (max-width: 767px) and (min-width: 0px) {
        height: 335px;
    }

    @media screen and (max-width: 991px) and (min-width: 768px) {
        height: 460px;
    }
}

.mybeauty {
  .banner {
    height: unset;
  }
}

.banner-no-msg {
 // height: unset !important;
}

.title {
    @media screen and (max-width: 767px) and (min-width: 0px) {
        font-size: 40px;
    }

    @media screen and (max-width: 991px) and (min-width: 768px) {
        font-size: 48px;
    }

    @media screen and (min-width: 992px) {
        font-size: 60px;
    }
}

.digital-rewards-card {
  @media screen and (max-width: 767px) and (min-width: 0px) {
    width: 197px;
    height: 127px;
  }

  @media screen and (max-width: 991px) and (min-width: 768px) {
    width: 358px;
    height: 230px;
  }

  @media screen and (max-width: 1199px) and (min-width: 992px) {
    width: 292px;
    height: 188px;
  }

  @media screen and (min-width: 1200px) {
    width: 280px;
    height: 180px;
  }
}
</style>
